/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./unwrap.css";
import bodyimg1mb from "../../Images/bodyimg1mb.webp";
import content from '../content.json';
import parse from 'html-react-parser';
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils";


export default function WelcomeSection({dataJson, realtorData}) {
const imgCDNURL = process.env.REACT_APP_HOMEOWNERSHIP_PROGRAM_CDN_URL;
const realtorName = realtorData ? capitalizeFirstLetter(realtorData.name) : "";
const realtorFirstName = realtorData ? capitalizeFirstLetter(realtorData.fisrtName) : "";
const {heading, para, whyChooseSunwest,tailoredTitle, tailoredPara, dedicatedTitle, dedicatedPara, dreamTitle, dreamPara, readyTitle, readyPara, readyPara1, readyPara2}= dataJson;

let mobilePhoneNumberFormatted,
    mobilePhoneNumberWithInternationalCode,
    mobilePhoneNumberInTitle,
    workPhoneNumberFormatted,
    workPhoneNumberWithInternationalCode,
    workPhoneNumberInTitle;
  try {
    mobilePhoneNumberFormatted = realtorData ? formatPhoneNumber(
      realtorData.mobilePhoneNumber
    ) : "";
    mobilePhoneNumberWithInternationalCode = realtorData ? addInternationalCode(
      realtorData.mobilePhoneNumber,
      "+1"
    ) : "";
    mobilePhoneNumberInTitle = "Contact me at " + mobilePhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get realtor mobile phone number.", error);
  }

  try {
    workPhoneNumberFormatted = realtorData ? formatPhoneNumber(realtorData.workPhoneNumber) : "";
    workPhoneNumberWithInternationalCode = realtorData ? addInternationalCode(
      realtorData.workPhoneNumber,
      "+1"
    ) : "";
    workPhoneNumberInTitle = "Contact me at " + workPhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get realtor work phone number.", error);
  }

  


  return (
    <>
      <div className="welcome-section">
        <Container>
          <Row className="welcome-row">
            <Col xs={12} sm={10} md={9} lg={8} className='welcome-col'>
              <div className='wrapper'>
              <div className='unwrap-bg'>
            <h5 className='unwrap-heading'>{parse(heading)}</h5>
            </div>
            <div className='homebuy-bg'>
            <p className='ready-para3'>{parse(para)}</p>
            </div>
            </div>
            </Col>
            <Col sm={10} md={12} lg={4}>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className='why-choose-sunwest-col'>
              <div className="bullet-line">
            <div className="left-line"></div>
              <p className='why-choose-sunwest'>{parse(whyChooseSunwest)}</p>
              <div className="right-line"></div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-between">
            <Col xs={12} sm={12} md={12} lg={4} className='tailored-col'>
              <img src={imgCDNURL +"tailored.webp"} className='whysunwest-img'></img>
              <h5 className='whysunwest-title'>{parse(tailoredTitle)}</h5>
              <p className='whysunwest-para'>{parse(tailoredPara)}</p>
            </Col>
            <Col xs={12} sm={12} md={12} lg={4} className='dedicated-col tailored-col'>
            <img src={imgCDNURL +"dedicated.webp"} className='whysunwest-img'></img>
              <h5 className='whysunwest-title'>{parse(dedicatedTitle)}</h5>
              <p className='whysunwest-para'>{parse(dedicatedPara)}</p>
            </Col>
            <Col xs={12} sm={12} md={12} lg={4} className='dream-col tailored-col'>
            <img src={imgCDNURL+ "dream-home.webp"} className='whysunwest-img3'></img>
              <h5 className='whysunwest-title'>{parse(dreamTitle)}</h5>
              <p className='whysunwest-para'>{parse(dreamPara)}</p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
      <Row className="ready-row">
            <Col XS={12} sm={12} md={12} lg={12} className='welcome-col'>
              <div className='wrapper'>
              <div className='ready-bg'>
                <img src={imgCDNURL + "phone-icon.webp"} className='phone-icon'></img>
            <h5 className='ready-heading'>{parse(readyTitle)}</h5>
            <img src={imgCDNURL + "message-icon.webp"} className='message-icon'></img>
            </div>
            <div className='ready-para-bg'>
            <p className='ready-para3'>{parse(readyPara)} {realtorName} {parse(readyPara1)} {realtorFirstName} at {" "}
             {realtorData?.workPhoneNumber ? (
                      <>
                        <a
                          style={{ textDecoration: "none" }}
                          href={"tel:" + workPhoneNumberWithInternationalCode}
                          title={workPhoneNumberInTitle}
                          aria-label={workPhoneNumberInTitle}
                        >
                        {workPhoneNumberFormatted}.
                        </a>
                      </>
                    ) : (
                      ""
                    )} 
                   {" "} {parse(readyPara2)}</p>
            </div>
            </div>
            </Col>
          </Row>
      </Container>
    </>
  );
}
